import i18next from 'i18next';

/**
 * Updates the document title based on the current language
 */
export const updateDocumentTitle = (): void => {
    // Get the current language
    const currentLang = i18next.language || 'en';

    // Set default title parts
    const siteName = i18next.t('site.title');

    // Set the document title
    document.title = `${siteName} - ${currentLang === 'en' ? 'Official Site' : 'Oficjalna Strona'}`;
};

/**
 * Updates the document language attribute based on the current language
 */
export const updateDocumentLanguage = (): void => {
    const currentLang = i18next.language || 'en';
    document.documentElement.setAttribute('lang', currentLang);
};

export default updateDocumentTitle; 